import React from 'react'
import PropTypes from 'prop-types'
import {
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
  LineChart,
  Line
} from 'recharts'
import ChartLegend from '../ChartLegend/ChartLegend.component'
import renderTooltip from 'analytics/components/Chart/Tooltip/Tooltip.component'
import moment from 'moment'
import setChartColor from 'shared/utils/chart/setChartColor'

const renderChartLegend = parentProps => props => <ChartLegend {...parentProps} {...props} />

const CartesianChart = props => {
  const {
    resultSet,
    children,
    ChartComponent,
    dimensions
  } = props

  return (
    <ResponsiveContainer width='100%' height={500}>
      <ChartComponent data={resultSet.chartPivot()}>
        <XAxis
          dataKey='x'
          tickFormatter={(label) => moment(label).format('MMM D')}
        />
        <YAxis />
        <CartesianGrid />
        { children }
        <Legend
          layout='vertical'
          verticalAlign='top'
          align='center'
          content={renderChartLegend(props)}
          dimensions={dimensions}
        />
        <Tooltip
          cursor={false}
          content={renderTooltip()}
        />
      </ChartComponent>
    </ResponsiveContainer>
  )
}

CartesianChart.propTypes = {
  resultSet: PropTypes.any,
  children: PropTypes.any,
  ChartComponent: PropTypes.any,
  dimensions: PropTypes.array
}

const lineRender = props => (
  <CartesianChart
    resultSet={props.resultSet}
    ChartComponent={LineChart}
    {...props}
  >
    {props.resultSet.seriesNames().map(series => {
      const lineColor = setChartColor({ 
        type: props.dimensions,
        key: series.key 
      })

      return (
        <Line
          type='monotone'
          key={series.key}
          stackId="a"
          dataKey={series.key}
          name={series.title}
          fill={lineColor}
          stroke={lineColor}
        />
      )
    })}
  </CartesianChart>
)

lineRender.propTypes = {
  resultSet: PropTypes.object,
  chartType: PropTypes.string,
  granularity: PropTypes.string,
  dateRange: PropTypes.string,
  customDateRange: PropTypes.object,
  channelNameToFilter: PropTypes.string,
  onChangeChartType: PropTypes.func,
  onChangeGranularity: PropTypes.func,
  onMoveCustomDateRange: PropTypes.func,
  dimensions: PropTypes.array
}

export default lineRender
